import { getRemotionEnvironment } from 'remotion';
import { EditorStarterAsset } from '../assets/assets';

// remoteUrl 또는 staticPath가 없는 에셋(업로드 중)만 블로킹
// localUrls 구독을 제거하여 remote→local 전환 시 불필요한 리렌더 방지
export const RequireCachedAsset = ({
  asset,
  children,
}: {
  asset: EditorStarterAsset;
  children: React.ReactNode;
}) => {
  if (getRemotionEnvironment().isRendering) {
    return children;
  }

  if (!asset.remoteUrl && !asset.staticPath) {
    return null;
  }

  return children;
};
